<template>
  <div
    class="header-menu-component clickable"
    @click="switchOpenClose()"
    @mouseleave="close(300)"
    @mouseenter="mouseEnter()"
  >
    <span class="text-nowrap" v-if="title">{{ title }}</span>
    <font-awesome-icon v-if="icon" :icon="icon" :class="{'ml-1': title}" />
    <div
      class="dropdown-content"
      v-if="resultOpen"
      :class="{'left': left, 'right': !left }"
      :style="{'top': dropdownTop}"
    >
      <slot>Slot is not set</slot>
    </div>
  </div>
</template>
<script>
import { setTimeout, clearTimeout } from "timers";
export default {
  props: ["icon", "title", "left", "hover", "force-open"],
  computed: {
    resultOpen() {
      return this.isOpen || this.forceOpen;
    }
  },
  data() {
    return {
      closeTimeout: null,
      isOpen: false,
      dropdownTop: "var(--header-height)"
    };
  },
  methods: {
    switchOpenClose() {
      this.isOpen = !this.isOpen;
    },
    open() {
      this.isOpen = true;
    },
    close(delay) {
      if (delay) {
        this.cancelClose();
        const _this = this;
        this.closeTimeout = setTimeout(() => {
          _this.isOpen = false;
        }, delay);
      } else {
        this.isOpen = false;
      }
    },
    mouseEnter() {
      this.cancelClose();
      if (this.hover) {
        this.open();
      }
    },
    cancelClose() {
      clearTimeout(this.closeTimeout);
    }
  },
  beforeUpdate() {
    if (this.$el && this.$el.clientHeight) {
      this.dropdownTop = this.$el.clientHeight + this.$el.offsetTop + "px";
    }
  }
};
</script>
<style lang="postcss">
.header-menu-component {
  .dropdown {
    position: relative;
    display: inline-block;

    &-content {
      position: absolute;
      background-color: #f9f9f9;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
      z-index: 1000000;
      top: var(--header-height);
      min-width: 150px;
      cursor: pointer;
      background-color: var(--bg-header);
      color: var(--color-header);

      &.left {
        left: 0;
      }
      &.right {
        right: 0;
      }
    }

    .visible {
      display: block;
    }

    &:hover .dropdown-content.hover-behaviour {
      display: block;
    }
  }
}
</style>